import { useMutation, useQueryClient } from '@tanstack/react-query';

import { enviosApi } from '../api';
import type { EnvioInformeWhatsAppRequest } from '../types';
import { enviosKeys } from './useEnvios';

export function useEnviarInformeParcialWhatsApp() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uidProtocolo,
      body,
    }: {
      uidProtocolo: string;
      body?: EnvioInformeWhatsAppRequest | null;
    }) => enviosApi.enviarParcialWhatsApp(uidProtocolo, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: enviosKeys.byProtocolo(variables.uidProtocolo),
      });
    },
  });
}

export function useEnviarInformeFinalWhatsApp() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uidProtocolo,
      body,
    }: {
      uidProtocolo: string;
      body?: EnvioInformeWhatsAppRequest | null;
    }) => enviosApi.enviarFinalWhatsApp(uidProtocolo, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: enviosKeys.byProtocolo(variables.uidProtocolo),
      });
    },
  });
}
